import { formatPrice, hasProductDiscount, hasProductPrice, isProductPriceHidden } from './price';

export const WHATSAPP_ORDER_NUMBER = '9647500322000';

export function openWhatsApp(message, phone = WHATSAPP_ORDER_NUMBER) {
  const digits = String(phone).replace(/\D/g, '');
  const text = encodeURIComponent(String(message ?? '').trim());
  const url = `https://wa.me/${digits}?text=${text}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

function isRemoteProductImage(image) {
  if (!image || typeof image !== 'string') return false;
  return /^https?:\/\//i.test(image);
}

export function buildProductConsultWhatsAppMessage({
  product,
  currency = 'د.ع',
  labels = {},
}) {
  const lines = [];
  const title = labels.title ?? '💬 پرسیار کردن — Crystal Bardawam';

  lines.push(title);
  lines.push('——————————');
  lines.push(`${labels.product ?? 'بەرهەم'}: ${product?.name ?? '—'}`);

  if (hasProductPrice(product)) {
    lines.push(`${labels.price ?? 'نرخ'}: ${formatPrice(product.price)} ${currency}`);
  }

  if (hasProductDiscount(product) && product?.originalPrice) {
    lines.push(
      `${labels.originalPrice ?? 'نرخی پێشوو'}: ${formatPrice(product.originalPrice)} ${currency}`,
    );
    if (product.discountPercent != null && product.discountPercent > 0) {
      lines.push(`${labels.discount ?? 'داشکاندن'}: ${product.discountPercent}%`);
    }
  }

  if (isRemoteProductImage(product?.image)) {
    lines.push(`🖼️ ${product.image}`);
  }

  return lines.join('\n');
}

export function buildCartWhatsAppMessage({
  type = 'order',
  items = [],
  totals,
  city,
  coords,
  user,
  currency = 'د.ع',
  labels = {},
}) {
  const lines = [];
  const isConsult = type === 'consult';

  lines.push(isConsult ? (labels.consultTitle ?? 'پرسیار کردن') : (labels.orderTitle ?? 'داواکاری نوێ'));
  lines.push('────────────────');

  if (user?.name) lines.push(`${labels.name ?? 'ناو'}: ${user.name}`);
  const phone = user?.phone ?? user?.number;
  if (phone) lines.push(`${labels.phone ?? 'ژمارە'}: ${phone}`);
  const cityName =
    typeof city?.name === 'string'
      ? city.name
      : city?.name?.ku || city?.name?.ar || city?.name?.en || '';
  if (cityName) lines.push(`${labels.city ?? 'شار'}: ${cityName}`);
  if (!isConsult && coords?.latitude != null && coords?.longitude != null) {
    lines.push(
      `${labels.map ?? 'نەخشە'}: https://www.google.com/maps?q=${coords.latitude},${coords.longitude}`,
    );
  }

  lines.push('');
  lines.push(labels.items ?? 'بەرهەمەکان:');
  items.forEach((entry, index) => {
    const name = entry.product?.name ?? '—';
    const qty = entry.quantity ?? 1;
    const price = entry.product?.price;
    const note = (entry.note ?? '').trim();
    let line = `${index + 1}. ${name} × ${qty}`;
    if (!isProductPriceHidden(entry.product) && price != null && price !== '') {
      line += ` — ${price} ${currency}`;
    }
    lines.push(line);
    if (note) lines.push(`   ${labels.note ?? 'تێبینی'}: ${note}`);
  });

  if (totals) {
    lines.push('');
    if (totals.productsSubtotal != null) {
      lines.push(`${labels.subtotal ?? 'کۆ'}: ${totals.productsSubtotal} ${currency}`);
    }
    if (totals.deliveryFee != null) {
      lines.push(
        totals.hasFreeDelivery
          ? `${labels.delivery ?? 'گەیاندن'}: ${labels.freeDelivery ?? 'خۆڕایی'}`
          : `${labels.delivery ?? 'گەیاندن'}: ${totals.deliveryFee} ${currency}`,
      );
    }
    if (totals.grandTotal != null) {
      lines.push(`${labels.grandTotal ?? 'کۆی گشتی'}: ${totals.grandTotal} ${currency}`);
    }
  }

  return lines.join('\n');
}
